import { render, staticRenderFns } from "./VTNavbar.vue?vue&type=template&id=4e8e41c8&"
import script from "./VTNavbar.vue?vue&type=script&lang=js&"
export * from "./VTNavbar.vue?vue&type=script&lang=js&"
import style0 from "./VTNavbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports